import { AppBar, Box, Grid, IconButton, Tabs, Toolbar } from "@mui/material"
import { styled } from "@mui/material/styles"
import { sharedStyle } from "../sharedTabsStyle"

const drawerWidth = "240px"
export const StyledAppBar = styled(AppBar)(({ theme }) => ({
  background: theme.palette.background.dark,
  position: "sticky",
  width: "100%",
  boxShadow: "none",
  paddingRight: "0px !important",
  // marginLeft: drawerWidth,
  minHeight: 48,
  "& a": {
    fontWeight: 400,
    opacity: 0.7
  },
  "& .Mui-selected": {
    color: "white!important",
    fontWeight: 700,
    opacity: 1
  },
  [theme.breakpoints.up("sm")]: {
    borderLeft: "3px solid rgba(0, 0, 0, 0.1)"
  }
}))

export const StyledIconButton = styled(IconButton)({
  marginLeft: 0,
  color: "white"
})

export const StyledImg = styled("img")({
  width: "100%",
  maxWidth: "100px",
  height: "auto",
  minHeight: "40px",
  overflow: "hidden"
})

export const StyledToolbar = styled(Toolbar)(({ theme, openDrawer }) => ({
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen
  }),
  justifyContent: "space-between",
  display: "flex",
  minHeight: "42px",

  [theme.breakpoints.down("sm")]: {
    marginLeft: 0
  },
  marginLeft: !openDrawer ? `56px` : `236px`,
  paddingLeft: 0,
  paddingRight: 0,
  [theme.breakpoints.up("sm")]: {
    minHeight: "41px",
    paddingLeft: 0,
    paddingRight: 0
  },
  "& .MuiTab-root": {
    minHeight: "52px"
  }
}))

export const StyledTabs = styled(Tabs)(({ theme }) => ({
  // TODO: responsive style not applying

  "& .MuiTab-root": {
    color: theme.palette.yellow[100]
  },
  flex: "1",
  "& a": {
    color: "white"
  },
  ".MuiTabs-root": {
    flex: 1,
    [theme.breakpoints.down("sm")]: {
      justifyContent: "center"
    }
  },
  ".MuiTabs-scroller": {
    [theme.breakpoints.down("md")]: {
      flexGrow: "0"
    }
  },
  ".MuiTabs-indicator": {
    height: 4
  },
  [theme.breakpoints.down("sm")]: {
    margin: "0 auto"
  }
}))

export const StyledBox = styled(Box)(({ theme }) => ({
  display: "none",
  [theme.breakpoints.only("sm")]: {
    display: "flex"
  }
}))

export const StyledAppBarContainer = styled(Box)(({ theme, flexend }) => ({
  display: "flex",
  justifyContent: flexend ? "flex-end" : "space-between",
  alignItems: "center",
  width: "100%",
  backgroundColor: theme.palette.secondary[800],
  "& .Mui-selected": {
    color: `${theme.palette.foreground.inverted} !important`,
    borderBottom: `2px solid ${theme.palette.primary[600]}`
  }
}))

export const StyledGrid = styled(Grid)(sharedStyle)
export const StyledSubTabs = styled(Tabs)(({ theme }) => ({
  ...sharedStyle,
  "& .MuiTab-root": {
    color: theme.palette.secondary[700]
  },
  backgroundColor: theme.palette.secondary[200],
  width: "100%",
  "& .Mui-selected": {
    color: `${theme.palette.secondary[700]} !important`,
    borderBottom: `3px solid ${theme.palette.primary[700]}`
  }
}))
